
import * as net from "@ivanlog/net";

export  enum LPXSwapDirection {
	Any = 0,
	InAnchor = 1,
	InFund = 2
}
export class AuthRequest extends net.Model {
	public sid: string;
	public signature: string;
	public address: string;
	public domainName: string;
	public domainVersion: string;
	public chainId: number;
	public verifyingContract: string;
	/**
	* @param {object} initObj - 
	*/
	constructor (initObj = {}){
		super("AuthRequest");
		this.sid = net.def.argString("sid", initObj);
		this.signature = net.def.argString("signature", initObj);
		this.address = net.def.argString("address", initObj);
		this.domainName = net.def.argString("domainName", initObj);
		this.domainVersion = net.def.argString("domainVersion", initObj);
		this.chainId = net.def.argInt("chainId", initObj);
		this.verifyingContract = net.def.argString("verifyingContract", initObj);
	}
}
export class DEXAnchorLiquidityComponentView extends net.Model {
	public anchorTokenId: number;
	public address: string;
	public symbol: string;
	public liquidityUsd: number;
	/**
	* @param {object} initObj - 
	*/
	constructor (initObj = {}){
		super("DEXAnchorLiquidityComponentView");
		this.anchorTokenId = net.def.argInt("anchorTokenId", initObj);
		this.address = net.def.argString("address", initObj);
		this.symbol = net.def.argString("symbol", initObj);
		this.liquidityUsd = net.def.argFloat("liquidityUsd", initObj);
	}
}
export class DEXPriceCandle extends net.Model {
	public openTS: number;
	public closeTS: number;
	public open: number;
	public high: number;
	public low: number;
	public close: number;
	public idxBuyPer100Usd: number;
	/**
	* @param {object} initObj - 
	*/
	constructor (initObj = {}){
		super("DEXPriceCandle");
		this.openTS = net.def.argInt("openTS", initObj);
		this.closeTS = net.def.argInt("closeTS", initObj);
		this.open = net.def.argFloat("open", initObj);
		this.high = net.def.argFloat("high", initObj);
		this.low = net.def.argFloat("low", initObj);
		this.close = net.def.argFloat("close", initObj);
		this.idxBuyPer100Usd = net.def.argFloat("idxBuyPer100Usd", initObj);
	}
}
export class DEXSwapExecutionBranchView extends net.Model {
	public amountIn: number;
	public amountOut: number;
	public tokenPathAddresses: Array<string>;
	public poolPathAddresses: Array<string>;
	/**
	* @param {object} initObj - 
	*/
	constructor (initObj = {}){
		super("DEXSwapExecutionBranchView");
		this.amountIn = net.def.argFloat("amountIn", initObj);
		this.amountOut = net.def.argFloat("amountOut", initObj);
		this.tokenPathAddresses = net.def.argSearch("tokenPathAddresses", initObj);
		if (!this.tokenPathAddresses) this.tokenPathAddresses = [];
		this.poolPathAddresses = net.def.argSearch("poolPathAddresses", initObj);
		if (!this.poolPathAddresses) this.poolPathAddresses = [];
	}
}
export class DEXSwapExecutionHopView extends net.Model {
	public tokenInAddress: string;
	public tokenOutAddress: string;
	public pool: DEXSwapRoutePoolView;
	/**
	* @param {object} initObj - 
	*/
	constructor (initObj = {}){
		super("DEXSwapExecutionHopView");
		this.tokenInAddress = net.def.argString("tokenInAddress", initObj);
		this.tokenOutAddress = net.def.argString("tokenOutAddress", initObj);
		this.pool = new DEXSwapRoutePoolView(net.def.argSearch("pool", initObj));
	}
}
export class DEXSwapExecutionPlanView extends net.Model {
	public tokenInAddress: string;
	public tokenOutAddress: string;
	public amountIn: number;
	public amountOut: number;
	public branches: Array<DEXSwapExecutionBranchView>;
	public slices: Array<DEXSwapExecutionSliceView>;
	/**
	* @param {object} initObj - 
	*/
	constructor (initObj = {}){
		super("DEXSwapExecutionPlanView");
		this.tokenInAddress = net.def.argString("tokenInAddress", initObj);
		this.tokenOutAddress = net.def.argString("tokenOutAddress", initObj);
		this.amountIn = net.def.argFloat("amountIn", initObj);
		this.amountOut = net.def.argFloat("amountOut", initObj);
		this.branches = [];
		const tempbranches = net.def.argSearch("branches", initObj);
		if (tempbranches)
		   tempbranches.forEach(obj => this.branches.push(new DEXSwapExecutionBranchView(obj)));
		this.slices = [];
		const tempslices = net.def.argSearch("slices", initObj);
		if (tempslices)
		   tempslices.forEach(obj => this.slices.push(new DEXSwapExecutionSliceView(obj)));
	}
}
export class DEXSwapExecutionRouteBranchView extends net.Model {
	public amountIn: number;
	public amountOut: number;
	public tokenPathAddresses: Array<string>;
	public hops: Array<DEXSwapExecutionHopView>;
	/**
	* @param {object} initObj - 
	*/
	constructor (initObj = {}){
		super("DEXSwapExecutionRouteBranchView");
		this.amountIn = net.def.argFloat("amountIn", initObj);
		this.amountOut = net.def.argFloat("amountOut", initObj);
		this.tokenPathAddresses = net.def.argSearch("tokenPathAddresses", initObj);
		if (!this.tokenPathAddresses) this.tokenPathAddresses = [];
		this.hops = [];
		const temphops = net.def.argSearch("hops", initObj);
		if (temphops)
		   temphops.forEach(obj => this.hops.push(new DEXSwapExecutionHopView(obj)));
	}
}
export class DEXSwapExecutionRouteView extends net.Model {
	public tokenInAddress: string;
	public tokenOutAddress: string;
	public amountIn: number;
	public amountOut: number;
	public branches: Array<DEXSwapExecutionRouteBranchView>;
	/**
	* @param {object} initObj - 
	*/
	constructor (initObj = {}){
		super("DEXSwapExecutionRouteView");
		this.tokenInAddress = net.def.argString("tokenInAddress", initObj);
		this.tokenOutAddress = net.def.argString("tokenOutAddress", initObj);
		this.amountIn = net.def.argFloat("amountIn", initObj);
		this.amountOut = net.def.argFloat("amountOut", initObj);
		this.branches = [];
		const tempbranches = net.def.argSearch("branches", initObj);
		if (tempbranches)
		   tempbranches.forEach(obj => this.branches.push(new DEXSwapExecutionRouteBranchView(obj)));
	}
}
export class DEXSwapExecutionSliceView extends net.Model {
	public amountIn: number;
	public amountOut: number;
	public tokenPathAddresses: Array<string>;
	public poolPathAddresses: Array<string>;
	/**
	* @param {object} initObj - 
	*/
	constructor (initObj = {}){
		super("DEXSwapExecutionSliceView");
		this.amountIn = net.def.argFloat("amountIn", initObj);
		this.amountOut = net.def.argFloat("amountOut", initObj);
		this.tokenPathAddresses = net.def.argSearch("tokenPathAddresses", initObj);
		if (!this.tokenPathAddresses) this.tokenPathAddresses = [];
		this.poolPathAddresses = net.def.argSearch("poolPathAddresses", initObj);
		if (!this.poolPathAddresses) this.poolPathAddresses = [];
	}
}
export class DEXSwapRouteCandidateView extends net.Model {
	public rank: number;
	public hopCount: number;
	public amountOut: number;
	public tokenPathAddresses: Array<string>;
	public poolPathAddresses: Array<string>;
	/**
	* @param {object} initObj - 
	*/
	constructor (initObj = {}){
		super("DEXSwapRouteCandidateView");
		this.rank = net.def.argInt("rank", initObj);
		this.hopCount = net.def.argInt("hopCount", initObj);
		this.amountOut = net.def.argFloat("amountOut", initObj);
		this.tokenPathAddresses = net.def.argSearch("tokenPathAddresses", initObj);
		if (!this.tokenPathAddresses) this.tokenPathAddresses = [];
		this.poolPathAddresses = net.def.argSearch("poolPathAddresses", initObj);
		if (!this.poolPathAddresses) this.poolPathAddresses = [];
	}
}
export class DEXSwapRoutePoolView extends net.Model {
	public poolId: number;
	public poolAddress: string;
	public token0Address: string;
	public token1Address: string;
	public token0Symbol: string;
	public token1Symbol: string;
	public token0Decimals: number;
	public token1Decimals: number;
	public reserve0Raw: string;
	public reserve1Raw: string;
	public feePpm: number;
	public updatedTS: number;
	public lastBlockId: number;
	public isHot: boolean;
	/**
	* @param {object} initObj - 
	*/
	constructor (initObj = {}){
		super("DEXSwapRoutePoolView");
		this.poolId = net.def.argInt("poolId", initObj);
		this.poolAddress = net.def.argString("poolAddress", initObj);
		this.token0Address = net.def.argString("token0Address", initObj);
		this.token1Address = net.def.argString("token1Address", initObj);
		this.token0Symbol = net.def.argString("token0Symbol", initObj);
		this.token1Symbol = net.def.argString("token1Symbol", initObj);
		this.token0Decimals = net.def.argInt("token0Decimals", initObj);
		this.token1Decimals = net.def.argInt("token1Decimals", initObj);
		this.reserve0Raw = net.def.argString("reserve0Raw", initObj);
		this.reserve1Raw = net.def.argString("reserve1Raw", initObj);
		this.feePpm = net.def.argInt("feePpm", initObj);
		this.updatedTS = net.def.argInt("updatedTS", initObj);
		this.lastBlockId = net.def.argInt("lastBlockId", initObj);
		this.isHot = net.def.argBool("isHot", initObj);
	}
}
export class DEXTokenTierView extends net.Model {
	public tokenId: number;
	public address: string;
	public symbol: string;
	public tier: string;
	public liquidityUsd: number;
	public flowTotalLiquidityUsd: number;
	public flowByAnchor: Array<DEXAnchorLiquidityComponentView>;
	/**
	* @param {object} initObj - 
	*/
	constructor (initObj = {}){
		super("DEXTokenTierView");
		this.tokenId = net.def.argInt("tokenId", initObj);
		this.address = net.def.argString("address", initObj);
		this.symbol = net.def.argString("symbol", initObj);
		this.tier = net.def.argString("tier", initObj);
		this.liquidityUsd = net.def.argFloat("liquidityUsd", initObj);
		this.flowTotalLiquidityUsd = net.def.argFloat("flowTotalLiquidityUsd", initObj, null);
		this.flowByAnchor = [];
		const tempflowByAnchor = net.def.argSearch("flowByAnchor", initObj);
		if (tempflowByAnchor)
		   tempflowByAnchor.forEach(obj => this.flowByAnchor.push(new DEXAnchorLiquidityComponentView(obj)));
	}
}
export class DEXTrackedPoolReserveView extends net.Model {
	public poolId: number;
	public poolAddress: string;
	public token0Address: string;
	public token1Address: string;
	public token0Symbol: string;
	public token1Symbol: string;
	public token0Decimals: number;
	public token1Decimals: number;
	public reserve0Raw: string;
	public reserve1Raw: string;
	public feePpm: number;
	public updatedTS: number;
	public lastBlockId: number;
	public isHot: boolean;
	/**
	* @param {object} initObj - 
	*/
	constructor (initObj = {}){
		super("DEXTrackedPoolReserveView");
		this.poolId = net.def.argInt("poolId", initObj);
		this.poolAddress = net.def.argString("poolAddress", initObj);
		this.token0Address = net.def.argString("token0Address", initObj);
		this.token1Address = net.def.argString("token1Address", initObj);
		this.token0Symbol = net.def.argString("token0Symbol", initObj);
		this.token1Symbol = net.def.argString("token1Symbol", initObj);
		this.token0Decimals = net.def.argInt("token0Decimals", initObj);
		this.token1Decimals = net.def.argInt("token1Decimals", initObj);
		this.reserve0Raw = net.def.argString("reserve0Raw", initObj);
		this.reserve1Raw = net.def.argString("reserve1Raw", initObj);
		this.feePpm = net.def.argInt("feePpm", initObj);
		this.updatedTS = net.def.argInt("updatedTS", initObj);
		this.lastBlockId = net.def.argInt("lastBlockId", initObj);
		this.isHot = net.def.argBool("isHot", initObj);
	}
}
export class LPXInfo extends net.Model {
	public poolId: number;
	public lastChangedBlockId: number;
	public poolType: number;
	public isSolo: boolean;
	public isClosed: boolean;
	public managerAddress: string;
	public packRaw: string;
	public liquidityProvidersAllTimeCount: number;
	public liquidityProvidersCount: number;
	public fundToken: LPXTokenInfo;
	public anchorToken: LPXTokenInfo;
	public reserves: LPXReservesInfo;
	public feeIndex: number;
	public managerRewardIndex: number;
	public ntzIndex: number;
	public profitIndex: number;
	public sharesTotalRaw: string;
	public profitPerShareRaw: string;
	public profitPerShareArbRaw: string;
	public shareMy: LPXShare;
	public shareMyArb: LPXShare;
	public aprAllTime: number;
	public apr30d: number;
	public liquidityFlow24h: LPXLiquidityFlowInfo;
	public liquidityFlow7d: LPXLiquidityFlowInfo;
	/**
	* @param {object} initObj - 
	*/
	constructor (initObj = {}){
		super("LPXInfo");
		this.poolId = net.def.argInt("poolId", initObj);
		this.lastChangedBlockId = net.def.argInt("lastChangedBlockId", initObj);
		this.poolType = net.def.argInt("poolType", initObj);
		this.isSolo = net.def.argBool("isSolo", initObj);
		this.isClosed = net.def.argBool("isClosed", initObj);
		this.managerAddress = net.def.argString("managerAddress", initObj);
		this.packRaw = net.def.argString("packRaw", initObj);
		this.liquidityProvidersAllTimeCount = net.def.argInt("liquidityProvidersAllTimeCount", initObj);
		this.liquidityProvidersCount = net.def.argInt("liquidityProvidersCount", initObj);
		this.fundToken = new LPXTokenInfo(net.def.argSearch("fundToken", initObj));
		this.anchorToken = new LPXTokenInfo(net.def.argSearch("anchorToken", initObj));
		this.reserves = new LPXReservesInfo(net.def.argSearch("reserves", initObj));
		this.feeIndex = net.def.argFloat("feeIndex", initObj);
		this.managerRewardIndex = net.def.argFloat("managerRewardIndex", initObj);
		this.ntzIndex = net.def.argFloat("ntzIndex", initObj);
		this.profitIndex = net.def.argFloat("profitIndex", initObj);
		this.sharesTotalRaw = net.def.argString("sharesTotalRaw", initObj);
		this.profitPerShareRaw = net.def.argString("profitPerShareRaw", initObj);
		this.profitPerShareArbRaw = net.def.argString("profitPerShareArbRaw", initObj);
		this.shareMy = new LPXShare(net.def.argSearch("shareMy", initObj));
		this.shareMyArb = new LPXShare(net.def.argSearch("shareMyArb", initObj));
		this.aprAllTime = net.def.argFloat("aprAllTime", initObj);
		this.apr30d = net.def.argFloat("apr30d", initObj);
		this.liquidityFlow24h = new LPXLiquidityFlowInfo(net.def.argSearch("liquidityFlow24h", initObj));
		this.liquidityFlow7d = new LPXLiquidityFlowInfo(net.def.argSearch("liquidityFlow7d", initObj));
	}
}
export class LPXLiquidityFlowInfo extends net.Model {
	public fundInRaw: string;
	public fundOutRaw: string;
	public anchorInRaw: string;
	public anchorOutRaw: string;
	/**
	* @param {object} initObj - 
	*/
	constructor (initObj = {}){
		super("LPXLiquidityFlowInfo");
		this.fundInRaw = net.def.argString("fundInRaw", initObj);
		this.fundOutRaw = net.def.argString("fundOutRaw", initObj);
		this.anchorInRaw = net.def.argString("anchorInRaw", initObj);
		this.anchorOutRaw = net.def.argString("anchorOutRaw", initObj);
	}
}
export class LPXProfit extends net.Model {
	public poolId: number;
	public apr: number;
	/**
	* @param {object} initObj - 
	*/
	constructor (initObj = {}){
		super("LPXProfit");
		this.poolId = net.def.argInt("poolId", initObj);
		this.apr = net.def.argFloat("apr", initObj);
	}
}
export class LPXReservesInfo extends net.Model {
	public fundRaw: string;
	public fundImgRaw: string;
	public anchorRaw: string;
	public anchorImgRaw: string;
	/**
	* @param {object} initObj - 
	*/
	constructor (initObj = {}){
		super("LPXReservesInfo");
		this.fundRaw = net.def.argString("fundRaw", initObj);
		this.fundImgRaw = net.def.argString("fundImgRaw", initObj);
		this.anchorRaw = net.def.argString("anchorRaw", initObj);
		this.anchorImgRaw = net.def.argString("anchorImgRaw", initObj);
	}
}
export class LPXSearchRequest extends net.Model {
	public skip: number;
	public take: number;
	public sid: string;
	public forWalletAdr: string;
	public forToken: string;
	public isFilterPorfolio: boolean;
	public isFilterManager: boolean;
	public isFilterOnlySolo: boolean;
	/**
	* @param {object} initObj - 
	*/
	constructor (initObj = {}){
		super("LPXSearchRequest");
		this.skip = net.def.argInt("skip", initObj);
		this.take = net.def.argInt("take", initObj);
		this.sid = net.def.argString("sid", initObj);
		this.forWalletAdr = net.def.argString("forWalletAdr", initObj);
		this.forToken = net.def.argString("forToken", initObj);
		this.isFilterPorfolio = net.def.argBool("isFilterPorfolio", initObj);
		this.isFilterManager = net.def.argBool("isFilterManager", initObj);
		this.isFilterOnlySolo = net.def.argBool("isFilterOnlySolo", initObj);
	}
}
export class LPXShare extends net.Model {
	public shareRaw: string;
	public pendingRaw: string;
	public debtRaw: string;
	/**
	* @param {object} initObj - 
	*/
	constructor (initObj = {}){
		super("LPXShare");
		this.shareRaw = net.def.argString("shareRaw", initObj);
		this.pendingRaw = net.def.argString("pendingRaw", initObj);
		this.debtRaw = net.def.argString("debtRaw", initObj);
	}
}
export class LPXSwapInfo extends net.Model {
	public poolId: number;
	public timestamp: number;
	public direction: LPXSwapDirection;
	public fundDeltaRaw: string;
	public anchorDeltaRaw: string;
	/**
	* @param {object} initObj - 
	*/
	constructor (initObj = {}){
		super("LPXSwapInfo");
		this.poolId = net.def.argInt("poolId", initObj);
		this.timestamp = net.def.argInt("timestamp", initObj);
		this.direction = net.def.argEnum("direction", initObj, LPXSwapDirection);
		this.fundDeltaRaw = net.def.argString("fundDeltaRaw", initObj);
		this.anchorDeltaRaw = net.def.argString("anchorDeltaRaw", initObj);
	}
}
export class LPXTokenInfo extends net.Model {
	public lpxAddress: string;
	public erc20Address: string;
	public name: string;
	public symbol: string;
	public decimals: number;
	public isBan: boolean;
	/**
	* @param {object} initObj - 
	*/
	constructor (initObj = {}){
		super("LPXTokenInfo");
		this.lpxAddress = net.def.argString("lpxAddress", initObj);
		this.erc20Address = net.def.argString("erc20Address", initObj);
		this.name = net.def.argString("name", initObj);
		this.symbol = net.def.argString("symbol", initObj);
		this.decimals = net.def.argInt("decimals", initObj);
		this.isBan = net.def.argBool("isBan", initObj);
	}
}
export class NBResult extends net.Model {
	public status: number;
	public code: number;
	public message: string;
	public description: string;
	/**
	* @param {object} initObj - 
	*/
	constructor (initObj = {}){
		super("NBResult");
		this.status = net.def.argInt("status", initObj);
		this.code = net.def.argInt("code", initObj);
		this.message = net.def.argString("message", initObj);
		this.description = net.def.argString("description", initObj);
	}
}
export class OkResult extends net.Model {
	public statusCode: number;
	/**
	* @param {object} initObj - 
	*/
	constructor (initObj = {}){
		super("OkResult");
		this.statusCode = net.def.argInt("statusCode", initObj);
	}
}
